import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import * as z from "zod";

export const warmExchangeAgentCachesV2 = {
  name: "warmExchangeAgentCachesV2" as const,
  input: z.object({
    draftReturnId: z.string(),
    currentReturnProductId: z.string(),
    productsBeingReturned: z.array(ReturnProductSchema),
  }),
  output: z.void(),
};
